import useShopSuspense from "@babackapp/private-api-client/client/use-shop-suspense";
import { useWorkflowsEditorRouting } from "../context/workflows-editor-routing-context";

export default function useCurrentShopSuspense() {
  const { shopId } = useWorkflowsEditorRouting();
  return useShopSuspense(shopId);
}
